import React from 'react';
import {BrowserRouter as Router ,Switch,Route} from 'react-router-dom';
import './App.css';
import Home from './Components/Home/Home.jsx';
import NavBar from './Components/NavBar/NavBar';
import "bootstrap/dist/css/bootstrap.min.css";
import { MyTimeline } from './Components';

const App=()=>{
  return(
    <Router>
    <div className="App" >
    <NavBar/>
    <Switch>
      <Route path='/' component={Home}/>
      <Route path="/about" component={MyTimeline}/>
      {/* <Route exact path='/projects' component={Projects}/> */}
    </Switch>
    </div>
    </Router>
   
  )
}

export default App;
